<template>
  <el-tooltip placement="top" content="ビュースタイルを変更">
    <el-dropdown placement="bottom-start" trigger="click">
      <span v-if="window_switch">
        <div class="window-switch-button">
          <font-awesome-icon :icon="['fal', 'sidebar-flip']" />
        </div>
      </span>
      <span v-else>
        <div class="window-switch-button">
          <font-awesome-icon :icon="['fal', 'window-restore']" />
        </div>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="windowSwitch(true)">
          <div class="flex-row">
            <div class="window-switch-check">
              <font-awesome-icon :icon="['fas', 'check']" v-if="window_switch" />
            </div>
            <div>サイドで開く</div>
          </div>
        </el-dropdown-item>
        <el-dropdown-item @click.native="windowSwitch(false)">
          <div class="flex-row">
            <div class="window-switch-check">
              <font-awesome-icon :icon="['fas', 'check']" v-if="!window_switch" />
            </div>
            <div>新規ウィンドウで開く</div>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-tooltip>
</template>

<script>
export default {
  name: "windowSwitch",
  props: [""],
  data() {
    return {};
  },
  computed: {
    window_switch() {
      return this.$store.state.window_switch;
    },
  },
  created() {},
  mounted() {},
  methods: {
    windowSwitch(boolean) {
      this.$store.dispatch("windowSwitch", boolean);
    },
  },
  watch: {},
};
</script>

<style></style>
